<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab href="#applicants" ripple>{{$t('Applicants')}}</v-tab>
      <v-tab href="#work-styles" ripple>{{$t('WorkStyles')}}</v-tab>
    </v-tabs>
    <div :key="currentView">
      <component :is="currentView"></component>
    </div>
  </div>
</template>

<script>
import Applicants from './Applicants'
import WorkStyles from './WorkStyles'
export default {
  data() {
    return {
      currentView: 'applicants'
    }
  },
  components: {
    Applicants,
    WorkStyles
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/scgcareer/main.vue